import { createContext } from "react";

const AuthContext = createContext({
  login: () => undefined,
  logOut: () => undefined,
});

export default AuthContext;